import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { apiRequest } from "../../lib/request"

/**
 * Delete media attached to a post (e.g. uploaded from computer on a draft/review post).
 * DELETE /api/v1/posts/medias/post/:postId?mediaId=&mediaAssetId=
 *
 * For AI Asset Manager / library deletes, keep using mediaDeleteSlice.deleteMedia (DELETE /medias?mediaIds=).
 */
export const deletePostMedia = createAsyncThunk(
  "postMediaDelete/deletePostMedia",
  async ({ postId, mediaId, mediaAssetId }, { rejectWithValue }) => {
    try {
      if (postId == null || postId === "") {
        throw new Error("postId is required")
      }
      if (mediaId == null || mediaId === "") {
        throw new Error("mediaId is required")
      }
      if (mediaAssetId == null || mediaAssetId === "") {
        throw new Error("mediaAssetId is required")
      }

      const url = `/posts/${encodeURIComponent(postId)}/media?mediaId=${encodeURIComponent(mediaId)}&mediaAssetId=${encodeURIComponent(mediaAssetId)}`

      const response = await apiRequest(url, { method: "DELETE" })

      return { postId, mediaId, mediaAssetId, data: response }
    } catch (error) {
      console.error("Delete post media API error:", error)
      return rejectWithValue(error?.message || error?.error || "Failed to delete post media")
    }
  },
)

const postMediaDeleteSlice = createSlice({
  name: "postMediaDelete",
  initialState: {
    status: "idle",
    error: null,
    lastDeleted: null,
  },
  reducers: {
    resetPostMediaDeleteState: (state) => {
      state.status = "idle"
      state.error = null
      state.lastDeleted = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deletePostMedia.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(deletePostMedia.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.lastDeleted = {
          postId: action.payload.postId,
          mediaId: action.payload.mediaId,
          mediaAssetId: action.payload.mediaAssetId,
        }
      })
      .addCase(deletePostMedia.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { resetPostMediaDeleteState } = postMediaDeleteSlice.actions
export default postMediaDeleteSlice.reducer
